import React, {useContext} from 'react';
import './App.css';
import {Box, createTheme, CssBaseline, ThemeProvider, Typography} from "@mui/material";
import {DataProvider} from "./context/dataProvider";
import {Outlet} from "react-router-dom";
import {AuthContext, IAuthContext} from 'react-oauth2-code-pkce';
import {themeOptions} from "./config/theme/theme";
import useData from "./hooks/useData";


const AuthenticationErrorHandler = () => {
  const {
    error,
    isValidToken,
    refreshInProgress,
    refreshAccessToken
  }: IAuthContext = useContext(AuthContext);

  function checkAccessToken(): void {
    if (!isValidToken && !refreshInProgress) {
      refreshAccessToken();
    }
  }

  return (
    <>
      <Box onClick={() => checkAccessToken()} onScroll={() => checkAccessToken()} width="100%" minHeight="100vh" height="100%" display="flex" flexDirection="column" alignItems="center">
        {error && <Box width="100%" bgcolor="red" display="flex" justifyContent="center" color="white">
            <Typography p={1} fontSize="0.9em">Er ging iets mis bij het inloggen. Probeer opnieuw!</Typography>
        </Box>}
        <>
          <Outlet/>
        </>
      </Box>
    </>
  );
};

function App() {
  const theme = createTheme(themeOptions);
  return (
    <ThemeProvider theme={theme}>
      <DataProvider>
        <CssBaseline/>
        <AuthenticationErrorHandler/>
      </DataProvider>
    </ThemeProvider>
  );
}

export default App;
